import { LoadingSpinner, mqMin, space, SpaceBetween, tk, tok, tokPx, verticalGap } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

export const Wrapper = styled.div`
  max-width: ${tk('breakpoint_desktop_xl')};
  padding: ${tk('spacing_md')};
  margin: 0 auto;

  @media ${tk('mq_tablet')} {
    padding: ${tk('spacing_md')} ${tk('spacing_xl')};
  }
  @media ${tk('mq_desktop_md')} {
    padding: ${tk('spacing_md')} ${tk('spacing_3xl')};
  }
`
export const Content = styled.div`
  display: flex;
  position: relative;
  gap: ${tk('spacing_md')};
  max-width: ${tk('breakpoint_desktop_xl')};
  flex-direction: column;

  @media ${tk('mq_desktop_md')} {
    flex-direction: row;
    gap: ${tk('spacing_lg')};
  }
`
export const MainContent = styled.div`
  ${verticalGap('spacing_lg')}
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: ${tk('spacing_md')};
  margin-bottom: ${tk('spacing_5xl')};

  @media ${tk('mq_desktop_md')} {
    width: calc((100% / 3) * 2);
  }
`
export const SideBarContent = styled(SpaceBetween)`
  width: 100%;

  @media ${tk('mq_desktop_md')} {
    max-width: 400px;
    min-width: 288px;
    width: calc(100% / 3);
  }
`
export const PageLayout = styled.div`
  background: ${tk('color_semantic_bg_subdued')};
  min-height: 100vh;
`
export const Loader = styled(LoadingSpinner)`
  margin: 80px auto auto auto;
`

export const CheckoutTermsAndConditions = styled.div`
  background: ${tk('color_semantic_bg')};
  box-shadow: ${tk('shadow_lg_bottom')};
  padding: ${tk('spacing_md')};
  border-radius: ${tk('radius_large')};

  ${verticalGap('spacing_md')}
`

// UDS
export const CheckoutTermsAndConditionsUDS = styled.div`
  background: ${tok('semantics_views_background_color')};
  padding: ${space('primitives_space_16')};
  border-radius: ${tokPx('primitives_corner_radius_none')};
  border-top: ${tokPx('semantics_boxes_border_width')} solid ${tok('semantics_boxes_border_color')};
  border-bottom: ${tokPx('semantics_boxes_border_width')} solid ${tok('semantics_boxes_border_color')};
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_12')};
  margin-left: -${space('primitives_space_16')};
  margin-right: -${space('primitives_space_16')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    border-radius: ${tokPx('semantics_boxes_corner_radius')};
    border: ${tokPx('semantics_boxes_border_width')} solid ${tok('semantics_boxes_border_color')};
    padding: ${space('primitives_space_20')};
    margin-left: ${space('primitives_space_0')};
    margin-right: ${space('primitives_space_0')};
    width: 100%;
  }
`
